module.exports = __webpack_public_path__ + "static/img/connection_success.2d3a021.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/connections/connection_success.png
// module id = H8wL
// module chunks = 31